// Harvard College's concentrations, Harvard's word for majors (#2596, founder
// 2026-09-30: "majors offered by the college in the public page"). Read on
// 2026-09-30 from Harvard College's official Concentrations page
// (college.harvard.edu/academics/liberal-arts-sciences/concentrations): all
// 50 fields with the degree each leads to, B.A., B.S. or both. The Fields of
// Concentration handbook (handbook.college.harvard.edu) refused a headless
// read (403), so this page is the source. Secondary fields and special
// concentrations are left out. No flags: the college file holds no programs
// source. The KB list was the starting point; the College page wins.
const majors = {
    "slug": "harvard-university",
    "read": "2026-09-30",
    "intro": "Every Harvard College concentration (Harvard's word for a major) on the College's official Concentrations page, with the degree it leads to. Secondary fields and graduate programs are left out.",
    "groups": [
        {
            "name": "Harvard College concentrations",
            "source": {
                "label": "Harvard College, Concentrations",
                "url": "https://college.harvard.edu/academics/liberal-arts-sciences/concentrations"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Math",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Film, and Visual Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.A."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.A."
                },
                {
                    "name": "Chemical and Physical Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry and Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Study of Religion",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Planetary Sciences",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "Energy, Climate, and the Environment",
                    "degree": "B.A."
                },
                {
                    "name": "Engineering Sciences",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Engineering",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science and Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Folklore and Mythology",
                    "degree": "B.A."
                },
                {
                    "name": "Germanic Languages and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Government",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "History and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "History and Science",
                    "degree": "B.A."
                },
                {
                    "name": "History of Art and Architecture",
                    "degree": "B.A."
                },
                {
                    "name": "Human Developmental and Regenerative Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Human Evolutionary Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Integrative Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Molecular and Cellular Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Near Eastern Languages and Civilizations",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Slavic Literatures and Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Social Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "South Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.A."
                },
                {
                    "name": "Studies of Women, Gender, and Sexuality",
                    "degree": "B.A."
                },
                {
                    "name": "Theater, Dance & Media",
                    "degree": "B.A."
                }
            ]
        }
    ]
};

export default majors;
